import type { Route } from "./+types/root"
import { appTimeContext } from "./context/app-time-context"

export async function clientLoader({ context }: Route.ClientLoaderArgs) {
  const func = "rootLoader"
  console.log("🌀🔫", { func, context })
  const appTime = context.get(appTimeContext)
  console.log("🌀🏁", { func, appTime })
  return { appTime }
}
